import React from "react";

import { Button, Modal, Space, Typography } from "antd";
import { ExclamationCircleFilled } from "@ant-design/icons";
// utils

const { Text } = Typography;

interface DeleteModalProps {
  showModal: boolean;
  onDelete: () => void;
  onClose: () => void;
  content?: React.ReactNode;
  title?: string;
  loadingDelete?: boolean;
  loadingCancel?: boolean;
  disableDelete?: boolean;
  disabledCancel?: boolean;
}

const DeleteModal: React.FC<DeleteModalProps> = ({
  showModal,
  onDelete,
  onClose,
  content,
  title,
  loadingDelete,
  loadingCancel,
  disableDelete,
  disabledCancel
}: DeleteModalProps) => {
  return (
    <Modal
      title={
        <Space>
          <ExclamationCircleFilled style={{ color: "#faad14", fontSize: 20 }} />
          {title ? title : "Warning!"}
        </Space>
      }
      open={showModal}
      onCancel={onClose}
      footer={[
        <Button key="cancel" onClick={onClose} disabled={disabledCancel} loading={loadingCancel}>
          Cancel
        </Button>,
        <Button key="delete" danger type="primary" onClick={onDelete} disabled={disableDelete} loading={loadingDelete}>
          Delete
        </Button>,
      ]}
    >
      {content ? content : <Text>Are you sure you want to delete this item? This action is permanent.</Text>}
    </Modal>
  );
};
export default DeleteModal;
